import { Box } from '@mentimeter/ragnar-ui/box';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { ScalesPresentation } from './ScalesPresentation';
import { TrendsDataHandler } from './visualizations/Trends';
import { useScalesPresentation } from './hooks/use-scales-presentation';

export function ScalesPresentationDataHandler() {
  const { useTrends } = usePresentationContext();

  const { ...presentationProps } = useScalesPresentation();
  const { showTrends: shouldShowTrends } = useTrends();

  return (
    <ScalesPresentation {...presentationProps}>
      {shouldShowTrends && (
        <Box flex="1" width="100%">
          <TrendsDataHandler
            choices={presentationProps.choices}
            range={presentationProps.range}
            shouldHideResults={presentationProps.shouldHideResults}
          />
        </Box>
      )}
    </ScalesPresentation>
  );
}
